export interface SubContractorUpdateModel {
    legalEntityId?: string;
    link?: string;
    hasAgreement: boolean;
}

export enum ContractPartyKind {
    Internal,
    External,
}

// A draft row has no id of its own yet, so it borrows one to take part in the same single-expanded-row state as the
// saved parties. Each column gets its own, since both columns can hold a draft at the same time.
export function draftContractPartyId(kind: ContractPartyKind) {
    return kind === ContractPartyKind.Internal ? "new-internal-contract-party" : "new-external-contract-party";
}
